module.exports = __webpack_public_path__ + "img/pro_s1_icon1.0d535e79.png";